//LL: 16.07.19

import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

//import NumberField from './NumberField';
import StringField from './StringField';
//import { ColorBoxField } from './ColorBoxField';

import * as appTheme from '../ts/appTheme';

import {
    DiscreteIntervalsKind,
    getKindList_forDiscreteMapping,
    DiscreteIntervals_forKind,
    dataTypes,
    IKindListForDiscreteMapping
} from './DiscreteIntervals';

import * as Utils from '../ts/Utilities';

//LL: 26.10.21: add 'boolean'
//LL: 26.06.19: add 'number', instead of i, r
//LL: 17.05.19   and see Utilities.explainAttributeType(attrType)
//LL: without 's', without 'b':
//var dataTypes = [ 'i', 'r', 'date', 'datetime', 'time'];
//LL: 15.11.19: move to DiscreteIntervals:  //LL: 18.11.19: add 'string'
//var dataTypes = [ 'number', 'date', 'datetime', 'time', 'string'];

var dataTypesIndexDefault = 0;

class DiscreteMappingFieldRow extends React.Component<any, any> {
    //LL: 14.01.25 
    private references: {
        dataType?: HTMLElement; // HTMLDivElement;
        resultingType?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);
        // this.props.themeObj
    }

    normalize(value) {
        if (value.name == null) {
            delete value.discreteIntervals;
            delete value.dataType;
            delete value.resultingType;

            return;
        }

        //LL: wrong
        //if (value.value != null) {
        //    value.value = $.trim(value.value);
        //}

        //LL: 26.06.19: add 'number', instead of i, r
        if (value.dataType === 'i' || value.dataType === 'r') {
            value.dataType == 'number';
        }
    }

    getKindDescrObject(_kind: DiscreteIntervalsKind) {
        let KindList = this.props.resultingTypes;
        let kindObj = KindList[0]; //  as default,  or null ?
        _.each(KindList, function (obj: any, key) {
            if (obj.kind === _kind) {
                kindObj = obj;
                return;
            }
        });
        return kindObj;
    }

    processNameChange = (val) => {
        let obj = _.clone(this.props.value || {});
        obj.name = val;
        this.handleValueChange(obj);
    }
    processNameClick = (e) => {
        let obj = _.clone(this.props.value || {});
        obj.name = '';
        this.handleValueChange(obj);
    }

    processDataTypeChange = (e) => {
        let elem: any = this.references.dataType;
        let val = elem.value;
        let obj = _.clone(this.props.value || {});

        ////LL: clear discreteIntervals:
        //obj.discreteIntervals = null;

        //LL: 15.11.19: must clear Intervals when DataType is changed
        let defined =
            obj.discreteIntervals != null &&
            obj.discreteIntervals.values != null &&
            obj.discreteIntervals.values.length > 0;
        if (defined) {
            let result = confirm('When Data Type is changed, Intervals will be cleared.'); //  OK, Cancel
            if (result === false) {
                return;
            }
        }

        //  clear:  nullMapped remains
        //  or obj.discreteIntervals = null;
        if (defined) {
            delete obj.discreteIntervals.values;
            delete obj.discreteIntervals.labels;
        }

        obj.dataType = val;
        this.handleValueChange(obj);
    }

    processResultingTypeChange = (e) => {
        let elem: any = this.references.resultingType;
        let val: any = elem.value; // it is string, not integer
        let num = Number(val);
        if (!isNaN(num)) val = num;

        let obj = _.clone(this.props.value || {});

        //LL: 15.11.19:
        let defined =
            obj.discreteIntervals != null &&
            ((obj.discreteIntervals.labels != null && obj.discreteIntervals.labels.length > 0) ||
                obj.discreteIntervals.nullMappedValue != null);
        if (defined) {
            let result = confirm('When Resulting Type is changed, Mapped values will be cleared.'); //  OK, Cancel
            if (result === false) {
                return;
            }
        }

        //LL: clear discreteIntervals "labels":   and nullMappedValue
        let emptyMappedValue = '';
        let kindDescrObj = this.getKindDescrObject(val); // _kind: DiscreteIntervalsKind);
        if (kindDescrObj != null) {
            emptyMappedValue = kindDescrObj.emptyMappedValue;
        }
        if (
            obj.discreteIntervals != null &&
            obj.discreteIntervals.labels != null &&
            obj.discreteIntervals.labels.length > 0
        ) {
            let labels = _.map(obj.discreteIntervals.labels, function (a: any) {
                return emptyMappedValue;
            });
            obj.discreteIntervals.labels = labels;
        }
        if (obj.discreteIntervals != null && obj.discreteIntervals.nullMappedValue != null) {
            obj.discreteIntervals.nullMappedValue = emptyMappedValue;
        }

        obj.resultingType = val;
        this.handleValueChange(obj);
    }

    handleValueChange(value) {
        this.normalize(value);

        //LL: 08.04.19: changed => not inherited
        delete value.inherited;

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    }

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    }

    getRemoveButton(value) {
        if (value.name == null) {
            return;
        }

        //LL: 08.04.19:  "disabled" not used ?
        if (value.disabled === true) {
            return;
        }

        //LL: 08.04.19:
        if (value.inherited === true) {
            return <span className="glyphicon glyphicon-arrow-down"></span>;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    }

    getNameTitle(value) {
        return value.name || '';
    }

    getName(value) {
        let displayVal = value.name || '';

        if (value.name == null) {
            let displayValEmpty = (
                <button type="button" className="btn btn-default btn-sm" onClick={this.processNameClick}>
                    {'Add'}
                </button>
            );
            return (
                <div className="entity-select">
                    <div className="content">
                        <span className="value">{displayValEmpty}</span>
                    </div>
                </div>
            );
        }

        let readOnly = value.disabled === true;
        //LL: style="cursor:default" for readonly in StringField

        return (
            <StringField
                onChange={this.processNameChange}
                value={displayVal}
                readOnly={readOnly}
                allowNull={false}
                applyOnEnter={true}
                changeOnBlurOnly={true}
            />
        );
    }

    getDataType(value) {
        if (value.name == null) {
            return;
        }

        let displayVal = value.dataType || dataTypes[dataTypesIndexDefault];

        let readOnly = value.disabled === true;

        let style1: any = {};
        if (value.disabled === true) {
            style1.cursor = 'default';
        }

        let options = _.map(dataTypes, function (val) {
            return (
                <option key={val} value={val}>
                    {Utils.explainAttributeType(val)}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.dataType = input;
                }} //LL: 14.01.25
                className="form-control"
                style={style1}
                onChange={this.processDataTypeChange}
                value={displayVal}
                disabled={readOnly}
            >
                {options}
            </select>
        );
    }

    getResultingType(value) {
        if (value.name == null) {
            return;
        }

        //LL: it is "kind" of DiscreteIntervals
        //console.log("resultingTypes=" + this.props.resultingTypes);  // { kind: obj.kind, name: obj.columnHeader }

        let displayVal = value.resultingType || this.props.resultingTypes[0].kind;

        let readOnly = value.disabled === true;

        let style1: any = {};
        if (value.disabled === true) {
            style1.cursor = 'default';
        }

        let options = _.map(this.props.resultingTypes, function (val: any) {
            return (
                <option key={val.kind} value={val.kind}>
                    {val.name}
                </option>
            );
        });

        return (
            <select
                ref={(input) => {
                    this.references.resultingType = input;
                }} //LL: 14.01.25
                className="form-control"
                style={style1}
                onChange={this.processResultingTypeChange}
                value={displayVal}
                disabled={readOnly}
            >
                {options}
            </select>
        );
    }

    process_DiscreteIntervals_Change = (val) => {
        //   val:  { labels:[], values:[] }
        let obj = _.clone(this.props.value || {});
        obj.discreteIntervals = val;
        this.handleValueChange(obj);
    }

    getDiscreteIntervals(value) {
        if (value.name == null) {
            return;
        }

        let dataType = value.dataType || dataTypes[dataTypesIndexDefault];

        let resultingType = value.resultingType || this.props.resultingTypes[0].kind;

        let displayVal_discreteIntervals: any = value.discreteIntervals; //  may be null

        //  sample: kind={ DiscreteIntervalsKind.icon }
        return (
            <DiscreteIntervals_forKind
                value={displayVal_discreteIntervals}
                type={dataType}
                kind={resultingType}
                onChange={this.process_DiscreteIntervals_Change}
                themeObj={this.props.themeObj}
                glob={this.props.glob}
            />
        );
    }

    render() {
        let value = this.props.value || {};

        let style1: any = {};
        if (value.disabled === true) {
            style1.backgroundColor = '#eeeeee';
            style1.cursor = 'default';
        }

        return (
            <tr style={style1}>
                <td className="cell-remove">{this.getRemoveButton(value)}</td>
                <td className="cell-name" title={this.getNameTitle(value)}>
                    {this.getName(value)}
                </td>
                <td className="cell-dataType">{this.getDataType(value)}</td>
                <td className="cell-resultingType">{this.getResultingType(value)}</td>
                <td className="cell-scale">{this.getDiscreteIntervals(value)}</td>
            </tr>
        );
    }
}

function getState() {
    return {};
}

export default class DiscreteMappingField extends React.Component<any, any> {
    public static reduceByType(ColorMappingArr, aType) {
        if (ColorMappingArr == null) return null;
        let arr = [];
        _.each(ColorMappingArr, function (cm: any, index) {
            let toAdd = true;
            switch (aType) {
                case 'i':
                case 'r':
                    toAdd = cm.dataType === 'i' || cm.dataType === 'r' || cm.dataType === 'number';
                    break;
                case 'date':
                case 'datetime':
                    toAdd = cm.dataType === 'date' || cm.dataType === 'datetime';
                    break;
                case 'time':
                    toAdd = cm.dataType === 'time';
                    break;
            }
            if (toAdd) {
                arr.push(cm);
            }
        });

        return arr;
    }

    // DiscreteIntervalsKind
    private resultingTypes: IKindListForDiscreteMapping[] = [];

    constructor(props) {
        super(props);

        // this.props.themeObj

        //this.reorderStart = this.reorderStart.bind(this);
        //this.reorderStop = this.reorderStop.bind(this);

        this.resultingTypes = getKindList_forDiscreteMapping();
    }

    //LL: 18.02.20:  NOTE about Reorder vs Sorting: =============================
    //   Items can either reordered by user's DragDrop or sorted by some internal algorithm (alphabetically here)
    //   Previous solution was Reorder, but it is not convenient and mixing own/parent items is bad
    //   So, now it will be Sorting, see function getSortedValuesByName
    //============================================================================

    //LL: 18.02.20:
    //    Commented (don't remove)  startIndex, reorderStart, reorderStop, processReorder, "sortable"

    //private startIndex;
    //
    //reorderStart(e, ui) {
    //    this.startIndex = $(ui.item).index();
    //}
    //
    //reorderStop (e, ui) {
    //    if (this.startIndex == null) { return; }
    //
    //    let startIndex = this.startIndex;
    //    let stopIndex = $(ui.item).index();
    //
    //    this.startIndex = null;
    //
    //    //LL: see: https://gist.github.com/avakhov/7b9d2b1a354e59dbfa63
    //    //   Вызываем cancel, чтобы элементы местами поменял React.js
    //    //   $(me.getDOMNode()).sortable("cancel");
    //    //const tableBody = this.references.tableBody;
    //    let tableBody = ReactDOM.findDOMNode(this.refs['tableBody']);
    //    $(tableBody).sortable("cancel");
    //
    //    this.processReorder(startIndex, stopIndex);
    //}

    componentDidMount() {
        ////let tableBody = this.refs.tableBody;
        //let tableBody = ReactDOM.findDOMNode(this.refs['tableBody']);
        //
        //if (typeof $(tableBody).sortable === 'function') {
        //    $(tableBody).sortable({
        //        axis: 'y',
        //        forceHelperSize: true,
        //        items: 'tr:not(.empty)',
        //        opacity: 0.8,
        //        handle: '.cell-name',
        //        cursor: 'grabbing',
        //        start: this.reorderStart,
        //        stop: this.reorderStop
        //    });
        //}
    }

    componentWillUnmount() {
        ////let tableBody = this.refs.tableBody;
        //let tableBody = ReactDOM.findDOMNode(this.refs['tableBody']);
        //$(tableBody).sortable('destroy');
    }

    _onChange() {
        this.setState(getState.call(this));
    }

    //processReorder(start, stop) {
    //    if (start === stop) { return; }
    //
    //    let value = this.props.value.slice(0);
    //
    //    let item = value.splice(start, 1);
    //    value.splice(stop, 0, item[0]);
    //
    //    this.handleValueChange(value);
    //}

    handleValueChange(value) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    addRow = (obj) => {
        let arr = this.props.value.slice(0);

        obj.discreteIntervals = null; // or {} ?
        obj.dataType = dataTypes[dataTypesIndexDefault];
        obj.resultingType = this.resultingTypes[0].kind;

        obj.disabled = false;

        arr.push(obj);
        this.handleValueChange(arr);
    }

    changeRow = (obj, i) => {
        let arr = this.props.value.slice(0);
        let prev = arr.splice(i, 1, obj)[0];
        this.handleValueChange(arr);
    }

    removeRow = (i) => {
        let arr = this.props.value.slice(0);
        arr.splice(i, 1);
        this.handleValueChange(arr);
    }

    render() {
        let self = this;

        //LL: "optionThemeOwnAndParent" is from ThemeField.tsx  EditComponentDepsWrapper.render:

        let objThemeOwnAndParent = appTheme.getThemeOwnAndParentvalues(this.props);
        let ownValues = objThemeOwnAndParent.ownValues;
        let parentValues = objThemeOwnAndParent.parentValues;

        let aaa = appTheme.getSortedValuesByName(this.props.value); //LL: 17.02.20 return { arr: arr, indices: indices };

        //LL: 26.06.19: add 'number', instead of i, r
        let rows = _.map(
            //this.props.value,
            aaa.arr, //LL: 17.02.20
            function (obj: any, i) {
                let obj2: any = appTheme.setProperInheritedFlag(obj, ownValues, parentValues, 'DiscreteMappingField');
                //LL: may be null, if just removed
                if (obj2 == null) {
                    return null;
                }

                //LL: 26.06.19: add 'number', instead of i, r
                if (obj2.dataType === 'i' || obj2.dataType === 'r') {
                    if (obj2.dataType === 'i' && obj2.discreteIntervals != null) {
                        obj2.discreteIntervals.precision = 0;
                    }
                    obj2.dataType = 'number';
                }

                let j = aaa.indices[i]; //LL: 17.02.20

                //   i={ i }  was
                return (
                    <DiscreteMappingFieldRow
                        key={i + '-' + obj2.name}
                        i={j}
                        value={obj2}
                        resultingTypes={self.resultingTypes}
                        onChange={self.changeRow}
                        onRemove={self.removeRow}
                        themeObj={self.props.themeObj}
                        glob={self.props.glob}
                    />
                );
            }
        );

        let showTableHeaders = rows.length > 0;

        let style1 = { marginBottom: 5 }; // class "table" has margin-bottom:20px

        let style2 = {
            paddingBottom: 15
        };

        //LL: 04.12.19: by Leo:
        //   Resulting Type -> Target Type,   Source Data Type -> Source Type

        return (
            <div className={'discretemapping-field'}>
                <div className={'div-container'} style={style2}>
                    <div className="discretemapping-field-common"></div>
                    <table className={'table' + (this.props.border === true ? ' table-bordered' : '')} style={style1}>
                        {showTableHeaders === true ? (
                            <thead>
                                <tr>
                                    <th className="cell-remove"></th>
                                    <th className="cell-name">Name</th>
                                    <th className="cell-dataType">Source Type</th>
                                    <th className="cell-resultingType">Target Type</th>
                                    <th className="cell-scale">Discrete Intervals</th>
                                </tr>
                            </thead>
                        ) : null}
                        <tbody //ref="tableBody"
                        >
                            {rows}
                            <DiscreteMappingFieldRow
                                resultingTypes={self.resultingTypes}
                                onChange={this.addRow}
                                themeObj={this.props.themeObj}
                                glob={this.props.glob}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
